import { Card } from "react-bootstrap";
import { CardTable, Header, Icon, Title } from "../../../components/ConsultaPadrao/components";
import { isMobileDevice, toastError } from "../../../commons/utils";
import { model_grupo } from "../../../models";
import { useEffect, useRef, useState } from "react";
import { useAuth } from "../../../contexts/AuthProvider/useAuth";
import { ExCadastroPadrao } from "../../../components/ExCadastroPadrao";
import { Container, RowMain, RowWrapper, RowChild, ExpandButton, GrupoDescription } from "./styles";
import { ExButton } from "../../../components/ExButton";
import { Check, ChevronDown, ChevronRight, Plus } from "lucide-react";
import { toast } from "react-toastify";
import { Input } from "../../../components/Input";

export const Grupo = () => {
    const auth = useAuth();

    const refCadastroPadrao = useRef<any>(null);

    const [data, setData] = useState<any[]>([]);

    async function refresh() {
        await auth.get(model_grupo.api_get)
            .then((response: any) => {
                setData(curr => response.data
                    .map((grupo: any) => ({
                        ...grupo,
                        expandido: curr?.find(el => el.gruid === grupo.gruid)?.expandido,
                    }))
                    .filter((e: any) => e.gruativo === 1)
                    .sort((a: any, b: any) =>
                        a.grudescricao.localeCompare(b.grudescricao)
                    ));
                auth.refreshGrupos();
            })
            .catch((error: any) => {
                toastError(error);
            })
    }

    useEffect(() => {
        refresh();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const toggleExpandir = (gruid: number) => {
        setData(prevData =>
            prevData.map(grupo => grupo.gruid === gruid ? { ...grupo, expandido: !grupo.expandido } : grupo)
        );
    };

    const newGroup = (grudescricao: string, gruidpai: number) => {
        auth.post(model_grupo.api_post, { grudescricao, gruidpai, grutipo: 2 }).then(() => {
            toast.success('Registro cadastrado com sucesso.');
            refresh()
        }).catch((error: any) => {
            toast.error(error?.response?.data.error ? error?.response?.data.error : 'Erro ao concluir a operação.');
        })
    }

    const AddComponent = ({ gruid }: { gruid: number }) => {
        const ref = useRef<any>(null)
        const [showCheck, setShowCheck] = useState(false)

        const onAfterChange = (val: string) => {
            if (val)
                setShowCheck(true)
            else
                setShowCheck(false)
        }

        return (
            <RowWrapper style={{ marginLeft: '74px' }}>
                <Input ref={ref} id="novo" type="text" placeholder="Novo Grupo" md={'3'} onAfterChange={onAfterChange} />
                {showCheck &&
                    <ExButton
                        onClick={() => newGroup(ref.current?.getValue(), gruid)}
                        color={'transparent'}
                        style={{ display: 'flex', justifyContent: 'center', marginLeft: '16px', borderRadius: '50%', width: '30px', height: '30px', paddingLeft: 0, paddingRight: 0 }}
                        iconcenter={<Check />}
                    />}
            </RowWrapper>
        )
    }

    const RenderizarGrupo = ({ grupo, dishoverParent }: { grupo: any, dishoverParent?: any }) => {
        const [hovered, setHovered] = useState(false);

        const childs = data?.filter(g => g.gruidpai === grupo.gruid);
        const haschilds = childs && childs.length > 0;

        return (
            <RowMain key={grupo.gruid}
                onMouseEnter={(e) => setHovered(true)}
                onMouseLeave={(e) => setHovered(false)}>
                <RowWrapper>
                    {haschilds && (
                        <ExpandButton
                            onClick={() => toggleExpandir(grupo.gruid)}
                            iconcenter={grupo.expandido ? <ChevronDown width='16px' /> : <ChevronRight width='16px' />}
                        />
                    )}
                    <GrupoDescription haschilds={haschilds}>
                        {grupo.grudescricao}
                    </GrupoDescription>
                    {hovered && !haschilds &&
                        // <ExtraButton onClick={() => inactivateGroup(grupo.gruid)} icon={<CircleMinus size={18} />}>Inativar</ExtraButton>
                        <></>
                    }
                </RowWrapper>

                {grupo.expandido && haschilds && (
                    <RowChild style={{ maxHeight: grupo.expandido ? undefined : 0, marginLeft: '60px' }}>
                        {childs.map(child => <RenderizarGrupo grupo={(child)} dishoverParent={() => setHovered(false)} />)}
                        <AddComponent gruid={grupo.gruid} />
                    </RowChild>
                )}
                {!haschilds &&
                    <RowChild style={{ marginLeft: '60px' }}>
                        <AddComponent gruid={grupo.gruid} />
                    </RowChild>}
            </RowMain>
        );
    };

    return (
        <>
            <CardTable className={isMobileDevice() ? "m-3 mb-4 mt-3" : "m-4 mb-4"}>
                <Card.Body className={isMobileDevice() ? "p-1" : "p-2"}>
                    <Header style={{ display: isMobileDevice() ? 'block' : 'flex' }}>
                        <Title>
                            <Icon>{model_grupo.icon}</Icon>
                            {model_grupo.name}
                        </Title>
                        {model_grupo.base && <ExButton icon={<Plus />} onClick={() => refCadastroPadrao.current.openModal()}>Novo</ExButton>}
                    </Header>
                    <Container>
                        {data?.filter(grupo => grupo.gruidpai === null).map(grupo => <RenderizarGrupo grupo={(grupo)} />)}
                    </Container>
                </Card.Body>
            </CardTable>
            {model_grupo.base &&
                <ExCadastroPadrao ref={refCadastroPadrao} model={model_grupo} success={() => refresh()} />
            }
        </>
    )
}
